export default __webpack_public_path__ + "static/media/en_vrai_c@etait_bien_2.5d99a0fd.png";